import toast from 'react-hot-toast'

interface ToastOptions {
  title?: string
  description?: string
  variant?: 'default' | 'destructive'
}

function showToast({ title, description, variant }: ToastOptions) {
  const message = description ? `${title}\n${description}` : (title ?? '')
  if (variant === 'destructive') {
    toast.error(message)
  } else {
    toast.success(message)
  }
}

export function useToast() {
  return { toast: showToast }
}
